// all services
export const ourServices = [
  {
    id: 1,
    title: "Web Development",
    subHeading: "Crafting Digital Experiences That Drive Business Growth",
    image: require("../assets/images/services/web-dev1.jpeg"),
    desc: "AIBSH TECHNOLOGIES PVT LTD transforms your digital vision into powerful, scalable web solutions that not only look stunning but deliver measurable business results. From responsive corporate websites to complex enterprise applications, we build the digital foundation your business needs to thrive in the modern marketplace.",
    serviceDetails: {
      banner: require("../assets/images/services/web-dev/banner.jpeg"),
      img1: require("../assets/images/services/web-dev/1.jpeg"),
      img2: require("../assets/images/services/web-dev/2.jpeg"),
      whyChooseContent: {
        heading: "Why AIBSH TECHNOLOGIES PVT LTD Leads in Web Development Excellence",
        list: [
          {
            title: "Innovation-Driven Architecture",
            desc: "We leverage cutting-edge technologies like React 18, Next.js 14, and modern CSS frameworks to create web applications that are not just current, but future-ready and scalable for your growing business needs.",
          },
          {
            title: "Business-Focused Design",
            desc: "Every pixel and interaction is designed with your business objectives in mind. We don't just build websites—we create digital experiences that convert visitors into customers and drive your bottom line.",
          },
          {
            title: "Performance-Optimized Solutions",
            desc: "Our web applications are engineered for speed, security, and scalability. We ensure lightning-fast load times, bulletproof security, and seamless performance across all devices and platforms.",
          },
          {
            title: "Strategic Partnership Approach",
            desc: "We become an extension of your team, providing ongoing support, maintenance, and strategic guidance to ensure your web presence continues to evolve with your business and market demands.",
          },
        ],
      },
      ourExpertiseContent: [
        {
          img: require("../assets/images/services/web-dev/expertise1.png"),
          title: "Modern Single-Page Applications",
          list: [
            "Built with React, Vue.js, and Angular for lightning-fast, responsive user experiences.",
            "Advanced state management and real-time data synchronization for dynamic content delivery.",
          ],
        },
        {
          img: require("../assets/images/services/web-dev/expertise2.jpeg"),
          title: "Progressive Web Applications",
          list: [
            "Native app-like experiences with offline capabilities, push notifications, and instant loading.",
            "Cross-platform compatibility that works seamlessly on desktop, tablet, and mobile devices.",
          ],
        },
        {
          img: require("../assets/images/services/web-dev/expertise3.jpeg"),
          title: "SEO-Optimized Server-Side Rendering",
          list: [
            "Next.js and Nuxt.js powered applications for superior search engine visibility and performance.",
            "Pre-rendered content delivery for faster initial page loads and better user engagement.",
          ],
        },
        {
          img: require("../assets/images/services/web-dev/expertise4.jpeg"),
          title: "Enterprise E-Commerce Solutions",
          list: [
            "Custom e-commerce platforms with AI-powered recommendations, advanced inventory management, and secure payment processing.",
            "Scalable architecture designed to handle high traffic and complex business operations.",
          ],
        },
        {
          img: require("../assets/images/services/web-dev/expertise5.jpeg"),
          title: "Custom Content Management Systems",
          list: [
            "Tailored CMS solutions that give you complete control over your content and digital assets.",
            "User-friendly interfaces that empower your team to manage and update content efficiently.",
          ],
        },
      ],
      developmentProcess: [
        {
          img: require("../assets/images/services/web-dev/process1.jpeg"),
          title: "Strategic Discovery & Planning",
          list: [
            "Deep-dive analysis of your business goals, target audience, and competitive landscape.",
            "Comprehensive technical architecture planning and technology stack selection.",
            "Detailed project roadmap with clear milestones, deliverables, and success metrics.",
          ],
        },
        {
          img: require("../assets/images/services/web-dev/process2.jpeg"),
          title: "User-Centric Design & Prototyping",
          list: [
            "Interactive wireframes and high-fidelity prototypes that bring your vision to life.",
            "User experience optimization based on industry best practices and user behavior analysis.",
            "Iterative design process incorporating stakeholder feedback and usability testing.",
          ],
        },
        {
          img: require("../assets/images/services/web-dev/process3.jpeg"),
          title: "Agile Development & Quality Assurance",
          list: [
            "Modern development methodologies with continuous integration and deployment.",
            "Comprehensive testing protocols including unit, integration, and user acceptance testing.",
            "Performance optimization and security hardening for production-ready applications.",
          ],
        },
      ],
      solutionUseCases: {
        heading: "Revolutionize Your Business with Web Development Solutions",
        contentArr: [
          {
            title: "Use Case 1: E-Commerce Platforms",
            list: [
              "Example: Shopify",
              "Features: Secure payments, AR-powered shopping experiences.",
              "Impact: Reach a global audience with seamless shopping.",
            ],
          },
          {
            title: "Use Case 2: Healthcare Portals",
            list: [
              "Example: Telemedicine platforms",
              "Features: Appointment scheduling, video consultations.",
              "Impact: Improve patient accessibility and clinic efficiency.",
            ],
          },
          {
            title: "Use Case 3: Media Streaming Websites",
            list: [
              "Example: Netflix",
              "Features: Adaptive streaming, personalized playlists.",
              "Impact: On-demand content delivery for global audiences.",
            ],
          },
          {
            title: "Use Case 4: Interactive Learning Portals",
            list: [
              "Example: E-learning websites like Coursera",
              "Features: Gamified learning experiences, progress tracking.",
              "Impact: Boost student engagement and accessibility.",
            ],
          },
          {
            title: "Use Case 5: AR-Powered Real Estate Websites",
            list: [
              "Example: Virtual property tours",
              "Features: 360-degree views, immersive experiences.",
              "Impact: Revolutionize property showcasing and buying.",
            ],
          },
        ],
      },
    },
  },
  {
    id: 2,
    title: "App Development",
    subHeading: "Building Mobile Experiences That Transform User Engagement",
    image: require("../assets/images/services/app-dev1.jpeg"),
    desc: "AIBSH TECHNOLOGIES PVT LTD creates cutting-edge mobile applications that go beyond functionality to deliver exceptional user experiences. From native iOS and Android apps to cross-platform solutions, we build mobile experiences that engage users, drive business growth, and stay ahead of technological trends.",
    serviceDetails: {
      banner: require("../assets/images/services/app-dev/banner.jpeg"),
      img1: require("../assets/images/services/app-dev/1.jpeg"),
      img2: require("../assets/images/services/app-dev/2.jpeg"),
      whyChooseContent: {
        heading: "Why AIBSH TECHNOLOGIES PVT LTD Excels in Mobile App Innovation",
        list: [
          {
            title: "Next-Generation Technology Stack",
            desc: "We leverage the latest mobile technologies including AI integration, 5G optimization, and IoT connectivity to create apps that are not just current, but future-ready and technologically advanced.",
          },
          {
            title: "User-Centric Design Philosophy",
            desc: "Every app feature and interaction is designed with your users in mind. We create intuitive, engaging experiences that keep users coming back and drive meaningful engagement metrics.",
          },
          {
            title: "Performance-Optimized Architecture",
            desc: "Our mobile apps are engineered for speed, reliability, and scalability. We ensure smooth performance, minimal battery consumption, and seamless operation across all devices and network conditions.",
          },
          {
            title: "Comprehensive Development Lifecycle",
            desc: "From initial concept to app store deployment and ongoing maintenance, we provide end-to-end support ensuring your app continues to evolve and perform optimally in the competitive mobile landscape.",
          },
        ],
      },
      ourExpertiseContent: [
        {
          img: require("../assets/images/services/app-dev/expertise1.jpeg"),
          title: "Native Mobile Applications",
          list: [
            "Platform-specific development using Swift for iOS and Kotlin for Android.",
            "Optimized performance with full access to device capabilities and native UI components.",
          ],
        },
        {
          img: require("../assets/images/services/app-dev/expertise2.jpeg"),
          title: "Cross-Platform Solutions",
          list: [
            "Single codebase development using Flutter and React Native for maximum reach and efficiency.",
            "Consistent user experience across iOS, Android, and web platforms with reduced development costs.",
          ],
        },
        {
          img: require("../assets/images/services/app-dev/expertise3.jpeg"),
          title: "Progressive Web Applications",
          list: [
            "Web-based apps with native functionality including offline access and push notifications.",
            "No app store requirements with instant updates and cross-platform compatibility.",
          ],
        },
        {
          img: require("../assets/images/services/app-dev/expertise4.png"),
          title: "AI-Powered Mobile Solutions",
          list: [
            "Intelligent apps with machine learning, natural language processing, and computer vision capabilities.",
            "Personalized user experiences with predictive analytics and automated decision-making.",
          ],
        },
        {
          img: require("../assets/images/services/app-dev/expertise5.png"),
          title: "IoT-Connected Applications",
          list: [
            "Seamless integration with smart devices and IoT ecosystems for enhanced functionality.",
            "Real-time data synchronization and automated device control for smart home and industrial applications.",
          ],
        },
        {
          img: require("../assets/images/services/app-dev/expertise6.jpeg"),
          title: "Cloud-Native Mobile Apps",
          list: [
            "Scalable cloud infrastructure integration with AWS, Google Cloud, and Azure.",
            "Global accessibility with robust data storage, real-time synchronization, and enterprise-grade security.",
          ],
        },
        {
          img: require("../assets/images/services/app-dev/expertise7.jpeg"),
          title: "Immersive AR/VR Experiences",
          list: [
            "Cutting-edge augmented and virtual reality applications for gaming, retail, and training.",
            "3D visualization, interactive experiences, and immersive storytelling capabilities.",
          ],
        },
        {
          img: require("../assets/images/services/app-dev/expertise8.jpeg"),
          title: "Blockchain-Enabled Applications",
          list: [
            "Secure decentralized applications with smart contracts and cryptocurrency integration.",
            "Transparent transaction systems for finance, supply chain, and digital asset management.",
          ],
        },
        {
          img: require("../assets/images/services/app-dev/expertise9.jpeg"),
          title: "Wearable Technology Apps",
          list: [
            "Specialized applications for smartwatches, fitness trackers, and health monitoring devices.",
            "Real-time health tracking, activity monitoring, and seamless data synchronization.",
          ],
        },
        {
          img: require("../assets/images/services/app-dev/expertise10.jpeg"),
          title: "Healthcare Apps",
          list: [
            "Revolutionizing Patient Care We create secure, HIPAA-compliant apps for telemedicine, patient management, appointment scheduling, health monitoring, and fitness tracking. By integrating IoT and AI, these apps empower healthcare providers and improve patient outcomes.",
          ],
        },
        {
          img: require("../assets/images/services/app-dev/expertise11.jpeg"),
          title: "Gaming Apps",
          list: [
            "Innovative, Interactive, and Engaging Our gaming apps feature stunning graphics, AI-driven gameplay, and multiplayer capabilities. We use platforms like Unity and Unreal Engine to create engaging gaming experiences for mobile and cross-platform play.",
          ],
        },
        {
          img: require("../assets/images/services/app-dev/expertise12.jpeg"),
          title: "Real Estate Apps",
          list: [
            "Simplifying Property Transactions Our real estate apps feature virtual property tours, agent-buyer communication tools, customizable search filters, and location-based suggestions. They streamline the property search process, connecting buyers, sellers, and agents effortlessly.",
          ],
        },
        {
          img: require("../assets/images/services/app-dev/expertise13.jpeg"),
          title: "Enterprise Mobility Solutions",
          list: [
            "Empower Your Workforce We build enterprise apps that improve productivity, streamline operations, and enhance collaboration within organizations. These apps are tailored for workflows, employee management, and real-time analytics.",
          ],
        },
      ],
      developmentProcess: [
        {
          img: require("../assets/images/services/app-dev/process1.jpeg"),
          title: "Discovery & Planning",
          list: [
            "Understand business goals, target audience, and technical requirements.",
            "Perform market research and competitor analysis.",
            "Define project scope, milestones, and timelines.",
          ],
        },
        {
          img: require("../assets/images/services/app-dev/process2.jpeg"),
          title: "UI/UX Design & Prototyping",
          list: [
            "Create wireframes and interactive prototypes.",
            "Ensure user-friendly, accessible, and engaging design experiences.",
            "Iterate based on client feedback and usability testing.",
          ],
        },
        {
          img: require("../assets/images/services/app-dev/process3.jpeg"),
          title: "Development & Engineering",
          list: [
            "Implementing the app with cutting-edge technologies.",
            "Integrating APIs, databases, and third-party services.",
            "Ensuring performance optimization and security compliance",
          ],
        },
      ],
    },
  },
  {
    id: 3,
    title: "Custom Software Development",
    subHeading: "Tailored Solutions That Solve Your Unique Business Challenges",
    image: require("../assets/images/services/custom-software1.jpeg"),
    desc: "AIBSH TECHNOLOGIES PVT LTD specializes in creating bespoke software solutions that are perfectly aligned with your business processes and objectives. We don't believe in one-size-fits-all—we build custom software that addresses your specific challenges, streamlines operations, and drives measurable business outcomes.",
    serviceDetails: {
      banner: require("../assets/images/services/custom-software/banner.jpeg"),
      img1: require("../assets/images/services/custom-software/1.jpeg"),
      img2: require("../assets/images/services/custom-software/2.png"),
      whyChooseContent: {
        heading: "Why AIBSH TECHNOLOGIES PVT LTD Delivers Exceptional Custom Software Solutions",
        list: [
          {
            title: "Business-Centric Development Approach",
            desc: "We start by deeply understanding your business processes, challenges, and objectives before writing a single line of code. This ensures every solution is perfectly tailored to your specific needs and delivers maximum business value.",
          },
          {
            title: "Scalable & Future-Ready Architecture",
            desc: "Our custom software is built with scalability in mind, allowing your solutions to grow and evolve with your business. We use modern technologies and best practices to ensure long-term viability and performance.",
          },
          {
            title: "Cutting-Edge Technology Integration",
            desc: "We integrate the latest technologies including AI, blockchain, IoT, and cloud computing to create innovative solutions that give you a competitive advantage and position your business for future success.",
          },
          {
            title: "Seamless System Integration",
            desc: "Our custom software seamlessly integrates with your existing systems, APIs, and platforms, creating a unified technology ecosystem that enhances efficiency and eliminates data silos.",
          },
          {
            title: "Enterprise-Grade Security & Compliance",
            desc: "We prioritize data security and regulatory compliance, implementing robust security measures and ensuring your custom software meets industry standards and protects your sensitive business information.",
          },
        ],
      },
      ourExpertiseContent: [
        {
          img: require("../assets/images/services/custom-software/expertise1.png"),
          title: "Enterprise Resource Planning Systems",
          list: [
            "Custom ERP solutions that streamline business operations and improve efficiency.",
            "Integrated modules for finance, HR, inventory, and customer relationship management.",
          ],
        },
        {
          img: require("../assets/images/services/custom-software/expertise2.jpeg"),
          title: "Intelligent Automation Solutions",
          list: [
            "AI-powered automation that reduces manual tasks and improves decision-making.",
            "Machine learning algorithms for predictive analytics and intelligent process optimization.",
          ],
        },
        {
          img: require("../assets/images/services/custom-software/expertise3.jpeg"),
          title: "Cloud-Native Applications",
          list: [
            "Scalable SaaS platforms built for modern business requirements.",
            "Cloud migration strategies and serverless architecture for optimal performance.",
          ],
        },
        {
          img: require("../assets/images/services/custom-software/expertise4.jpeg"),
          title: "Blockchain & Decentralized Solutions",
          list: [
            "Secure decentralized applications with smart contract functionality.",
            "Digital asset management and transparent transaction systems.",
          ],
        },
        {
          img: require("../assets/images/services/custom-software/expertise5.jpeg"),
          title: "IoT Integration Platforms",
          list: [
            "Smart device connectivity and real-time data processing solutions.",
            "Predictive maintenance and automated monitoring systems.",
          ],
        },
        {
          img: require("../assets/images/services/custom-software/expertise6.jpeg"),
          title: "API-First Architecture",
          list: [
            "Robust API development for seamless system integration.",
            "Microservices architecture for scalable and maintainable solutions.",
          ],
        },
      ],
      developmentProcess: [
        {
          img: require("../assets/images/services/custom-software/process1.jpeg"),
          title: "Comprehensive Business Analysis",
          list: [
            "Deep-dive analysis of your business processes, pain points, and objectives.",
            "Detailed requirements gathering, user story creation, and technical feasibility assessment.",
          ],
        },
        {
          img: require("../assets/images/services/custom-software/process2.jpeg"),
          title: "Strategic Design & Architecture",
          list: [
            "Custom UI/UX design that aligns with your brand and user needs.",
            "Scalable technical architecture planning and technology stack selection.",
          ],
        },
        {
          img: require("../assets/images/services/custom-software/process3.jpeg"),
          title: "Agile Development & Quality Assurance",
          list: [
            "Iterative development with continuous testing and stakeholder feedback.",
            "Comprehensive quality assurance and performance optimization for production deployment.",
          ],
        },
      ],
      solutionUseCases: {
        heading:
          "Revolutionize Your Business with Custom Software Development Solutions",
        contentArr: [
          {
            title: "Use Case 1: AI-Driven Customer Support",
            list: [
              "Example: AI chatbots for instant customer assistance.",
              "Features: Automated responses, natural language understanding, and personalized engagement.",
              "Impact: Reduces response time and improves customer satisfaction.",
            ],
          },
          {
            title: "Use Case 2: Automated Logistics Management",
            list: [
              "Example: AI-powered route optimization software.",
              "Features: Real-time tracking, automated scheduling, and predictive analytics.",
              "Impact: Reduces fuel costs and improves delivery efficiency.",
            ],
          },
          {
            title: "Use Case 3: Cloud-Based SaaS Platforms",
            list: [
              "Example: Scalable business management software.",
              "Features: Remote accessibility, multi-user collaboration, and automated data backups.",
              "Impact: Enhances operational efficiency and reduces IT overhead.",
            ],
          },
        ],
      },
    },
  },
  {
    id: 4,
    title: "AI Solutions",
    subHeading: "Intelligent Automation That Transforms Business Operations",
    image: require("../assets/images/services/ai1.png"),
    desc: "AIBSH TECHNOLOGIES PVT LTD leverages cutting-edge artificial intelligence to create smart, automated solutions that revolutionize how your business operates. From intelligent chatbots to predictive analytics, we build AI systems that learn, adapt, and deliver measurable business value.",
    serviceDetails: {
      banner: require("../assets/images/services/ai/banner.jpeg"),
      img1: require("../assets/images/services/ai/1.png"),
      img2: require("../assets/images/services/ai/2.jpeg"),
      whyChooseContent: {
        heading: "Why AIBSH TECHNOLOGIES PVT LTD Leads in AI Innovation",
        list: [
          {
            title: "Custom AI Strategy Development",
            desc: "We don't implement generic AI solutions—we develop tailored AI strategies that align with your specific business objectives and deliver measurable ROI through intelligent automation and decision-making.",
          },
          {
            title: "Advanced Machine Learning Expertise",
            desc: "Our AI solutions leverage the latest machine learning algorithms and neural networks to provide predictive insights, automate complex processes, and create intelligent systems that continuously improve over time.",
          },
          {
            title: "Scalable AI Infrastructure",
            desc: "We build AI systems that grow with your business, ensuring they remain efficient, accurate, and cost-effective as your data volumes and processing requirements increase.",
          },
          {
            title: "Seamless Enterprise Integration",
            desc: "Our AI solutions integrate seamlessly with your existing software, CRMs, ERPs, and digital ecosystems, creating a unified intelligent platform that enhances your current operations.",
          },
          {
            title: "Security-First AI Implementation",
            desc: "We prioritize data security and regulatory compliance in all AI implementations, ensuring your intelligent systems protect sensitive information while meeting industry standards and requirements.",
          },
        ],
      },
      ourExpertiseContent: [
        {
          img: require("../assets/images/services/ai/expertise1.jpeg"),
          title: "Intelligent Conversational AI",
          list: [
            "Advanced chatbots and virtual assistants with natural language processing capabilities.",
            "Multi-language support and context-aware conversations for enhanced user engagement.",
          ],
        },
        {
          img: require("../assets/images/services/ai/expertise2.jpeg"),
          title: "Predictive Analytics & Business Intelligence",
          list: [
            "AI-powered forecasting models for business planning and strategic decision-making.",
            "Real-time analytics dashboards with automated insights and trend analysis.",
          ],
        },
        {
          img: require("../assets/images/services/ai/expertise3.jpeg"),
          title: "Computer Vision & Image Recognition",
          list: [
            "Advanced image and video analysis for quality control and automated inspection.",
            "Facial recognition and object detection for security and process automation.",
          ],
        },
        {
          img: require("../assets/images/services/ai/expertise4.jpeg"),
          title: "Natural Language Processing Solutions",
          list: [
            "Text analysis and sentiment detection for customer feedback and market research.",
            "Automated document processing and intelligent content generation.",
          ],
        },
        {
          img: require("../assets/images/services/ai/expertise5.jpeg"),
          title: "Intelligent Process Automation",
          list: [
            "AI-driven workflow automation that reduces manual tasks and improves efficiency.",
            "Smart decision-making systems for complex business processes and operations.",
          ],
        },
        {
          img: require("../assets/images/services/ai/expertise6.jpeg"),
          title: "Healthcare AI Solutions",
          list: [
            "AI-powered diagnostic tools and medical image analysis for improved patient care.",
            "Predictive healthcare analytics for early disease detection and treatment optimization.",
          ],
        },
        {
          img: require("../assets/images/services/ai/expertise7.png"),
          title: "AI-Powered Marketing & Personalization",
          list: [
            "Intelligent customer segmentation and personalized marketing campaigns.",
            "Dynamic content recommendations and automated marketing optimization.",
          ],
        },
        {
          img: require("../assets/images/services/ai/expertise8.jpeg"),
          title: "Financial AI & Risk Management",
          list: [
            "AI-powered fraud detection and risk assessment for financial institutions.",
            "Intelligent credit scoring and automated investment analysis systems.",
          ],
        },
      ],
      developmentProcess: [
        {
          img: require("../assets/images/services/ai/process1.jpeg"),
          title: "AI Strategy & Business Analysis",
          list: [
            "Comprehensive analysis of your business processes and AI implementation opportunities.",
            "Custom AI roadmap development with clear success metrics and ROI projections.",
          ],
        },
        {
          img: require("../assets/images/services/ai/process2.jpeg"),
          title: "Data Engineering & Model Development",
          list: [
            "Advanced data preprocessing and feature engineering for optimal AI model performance.",
            "Custom machine learning model development with continuous training and optimization.",
          ],
        },
        {
          img: require("../assets/images/services/ai/process3.jpeg"),
          title: "AI Integration & Deployment",
          list: [
            "Seamless integration of AI models into your existing business applications.",
            "Production deployment with monitoring, maintenance, and continuous improvement.",
          ],
        },
      ],
      solutionUseCases: {
        heading: "Revolutionize Your Business with AI Solutions",
        contentArr: [
          {
            title: "Use Case 1: AI-Powered Healthcare Diagnostics",
            list: [
              "Example: AI-driven analysis of X-rays and MRI scans.",
              "Features: Automated diagnosis, anomaly detection, and predictive health insights.",
              "Impact: Faster, more accurate diagnostics with reduced human error.",
            ],
          },
          {
            title: "Use Case 2: AI in E-Commerce & Customer Support",
            list: [
              "Example: AI-powered chatbots for personalized customer assistance.",
              "Features: 24/7 customer service, automated order tracking, and AI-driven recommendations.",
              "Impact: Improved customer engagement and increased conversion rates.",
            ],
          },
          {
            title: "Use Case 3: AI-Driven Financial Risk Analysis",
            list: [
              "Example: AI models for fraud detection and credit risk assessment.",
              "Features: Real-time fraud detection, AI-based loan approvals, and investment predictions.",
              "Impact: Reduced fraud losses and improved decision-making for financial institutions.",
            ],
          },
        ],
      },
    },
  },
  {
    id: 5,
    title: "Data Science & Analytics",
    subHeading: "Transforming Data into Strategic Business Intelligence",
    image: require("../assets/images/services/data-science1.jpeg"),
    desc: "AIBSH TECHNOLOGIES PVT LTD transforms your raw data into powerful business intelligence that drives strategic decision-making. We combine advanced analytics, machine learning, and data visualization to uncover insights that give you a competitive advantage and enable data-driven growth.",
    serviceDetails: {
      banner: require("../assets/images/services/data-science/banner.jpeg"),
      img1: require("../assets/images/services/data-science/1.png"),
      img2: require("../assets/images/services/data-science/2.jpeg"),
      whyChooseContent: {
        heading: "Why AIBSH TECHNOLOGIES PVT LTD Excels in Data Science & Analytics",
        list: [
          {
            title: "Strategic Data Intelligence",
            desc: "We don't just analyze data—we transform it into actionable business intelligence that aligns with your strategic objectives and drives measurable business outcomes.",
          },
          {
            title: "Advanced Analytics & Machine Learning",
            desc: "Our data science solutions leverage cutting-edge machine learning algorithms and predictive analytics to provide insights that help you anticipate trends and make informed decisions.",
          },
          {
            title: "Comprehensive Data Processing",
            desc: "From data collection and cleaning to analysis and visualization, we ensure your data is accurate, secure, and processed efficiently to deliver maximum business value.",
          },
          {
            title: "Scalable & Secure Infrastructure",
            desc: "We build robust data infrastructure that can handle massive datasets while maintaining enterprise-grade security and compliance with data protection regulations.",
          },
          {
            title: "Industry-Specific Analytics",
            desc: "Our data science solutions are tailored to your specific industry, providing relevant insights and analytics that address your unique business challenges and opportunities.",
          },
        ],
      },
      ourExpertiseContent: [
        {
          img: require("../assets/images/services/data-science/expertise1.jpeg"),
          title: "Predictive Analytics & Forecasting",
          list: [
            "Advanced forecasting models for business planning and strategic decision-making.",
            "Trend analysis and predictive insights for market opportunities and risk assessment.",
          ],
        },
        {
          img: require("../assets/images/services/data-science/expertise2.jpeg"),
          title: "Machine Learning & AI Models",
          list: [
            "Custom machine learning models for automation, fraud detection, and personalized recommendations.",
            "Deep learning and neural network solutions for complex pattern recognition and analysis.",
          ],
        },
        {
          img: require("../assets/images/services/data-science/expertise3.jpeg"),
          title: "Big Data Processing & Analytics",
          list: [
            "Scalable big data solutions using Hadoop, Spark, and cloud-based data processing platforms.",
            "Real-time data streaming and analytics for immediate business insights and decision-making.",
          ],
        },
        {
          img: require("../assets/images/services/data-science/expertise4.jpeg"),
          title: "Business Intelligence & Visualization",
          list: [
            "Interactive dashboards and data visualization tools for intuitive business intelligence.",
            "Real-time reporting and analytics platforms for data-driven decision-making.",
          ],
        },
        {
          img: require("../assets/images/services/data-science/expertise5.jpeg"),
          title: "Natural Language Processing & Text Analytics",
          list: [
            "Advanced text analysis and sentiment detection for customer feedback and market research.",
            "Automated document processing and intelligent content analysis for business insights.",
          ],
        },
        {
          img: require("../assets/images/services/data-science/expertise6.jpeg"),
          title: "Computer Vision & Image Analytics",
          list: [
            "AI-powered image and video analysis for quality control and automated inspection.",
            "Visual data processing for security, healthcare, and industrial applications.",
          ],
        },
        {
          img: require("../assets/images/services/data-science/expertise7.jpeg"),
          title: "Data Engineering & ETL Solutions",
          list: [
            "Robust data pipelines for efficient data extraction, transformation, and loading processes.",
            "Data warehouse design and optimization for scalable analytics and reporting.",
          ],
        },
        {
          img: require("../assets/images/services/data-science/expertise8.jpeg"),
          title: "Fraud Detection & Risk Analytics",
          list: [
            "Advanced fraud detection systems using machine learning and behavioral analytics.",
            "Risk assessment models for financial institutions and insurance companies.",
          ],
        },
      ],
      developmentProcess: [
        {
          img: require("../assets/images/services/data-science/process1.jpeg"),
          title: "Data Strategy & Business Analysis",
          list: [
            "Comprehensive analysis of your data landscape and business intelligence requirements.",
            "Custom data strategy development aligned with your business objectives and KPIs.",
          ],
        },
        {
          img: require("../assets/images/services/data-science/process2.jpeg"),
          title: "Data Engineering & Model Development",
          list: [
            "Advanced data preprocessing and feature engineering for optimal analytics performance.",
            "Custom machine learning model development with continuous training and validation.",
          ],
        },
        {
          img: require("../assets/images/services/data-science/process3.jpeg"),
          title: "Analytics Integration & Deployment",
          list: [
            "Seamless integration of analytics solutions into your existing business applications.",
            "Production deployment with monitoring, maintenance, and continuous optimization.",
          ],
        },
      ],
      solutionUseCases: {
        heading: "Revolutionize Your Business with Data Science Solutions",
        contentArr: [
          {
            title: "Use Case 1: AI-Powered Healthcare Analytics",
            list: [
              "Example: Predict patient readmission risks and optimize treatment plans.",
              "Impact: Improved patient outcomes and reduced operational costs.",
            ],
          },
          {
            title: "Use Case 2: Fraud Detection in Banking",
            list: [
              "Example: AI-powered risk analysis and real-time fraud detection.",
              "Impact: Enhanced security, reduced fraudulent transactions.",
            ],
          },
          {
            title: "Use Case 3: AI-Driven E-Commerce Personalization",
            list: [
              "Example: AI-powered recommendation engines for personalized shopping.",
              "Impact: Increased conversion rates and customer satisfaction.",
            ],
          },
          {
            title: "Use Case 4: Smart Logistics & Supply Chain Optimization",
            list: [
              "Example: Predictive analytics for route optimization and inventory forecasting.",
              "Impact: Reduced logistics costs and enhanced efficiency.",
            ],
          },
        ],
      },
    },
  },
  {
    id: 6,
    title: "Game Development",
    subHeading: "Creating Immersive Gaming Experiences That Captivate Audiences",
    image: require("../assets/images/services/game-dev1.jpeg"),
    desc: "AIBSH TECHNOLOGIES PVT LTD brings your gaming vision to life with cutting-edge technology and creative excellence. From mobile games to AAA titles, we develop immersive gaming experiences that engage players, drive user retention, and deliver exceptional entertainment value across all platforms.",
    serviceDetails: {
      banner: require("../assets/images/services/game-dev/banner.jpeg"),
      img1: require("../assets/images/services/game-dev/1.jpeg"),
      img2: require("../assets/images/services/game-dev/2.jpeg"),
      whyChooseContent: {
        heading: "Why AIBSH TECHNOLOGIES PVT LTD Leads in Game Development Innovation",
        list: [
          {
            title: "Cutting-Edge Game Engine Expertise",
            desc: "We master the latest Unity and Unreal Engine technologies to create visually stunning, high-performance games that push the boundaries of what's possible in modern gaming.",
          },
          {
            title: "Creative Vision & Technical Excellence",
            desc: "Every game we develop is a unique masterpiece that perfectly balances creative vision with technical innovation, ensuring engaging gameplay and exceptional user experiences.",
          },
          {
            title: "Comprehensive Development Lifecycle",
            desc: "From initial concept and storyboarding to final launch and post-release support, we handle every aspect of game development with meticulous attention to detail.",
          },
          {
            title: "Multi-Platform Gaming Solutions",
            desc: "We develop games that seamlessly work across PC, console, mobile, AR, and VR platforms, maximizing your reach and ensuring players can enjoy your game anywhere.",
          },
          {
            title: "Strategic Monetization & Business Growth",
            desc: "We implement intelligent monetization strategies including in-app purchases, premium content, and advertising that maximize revenue while maintaining player satisfaction.",
          },
        ],
      },
      ourExpertiseContent: [
        {
          img: require("../assets/images/services/game-dev/expertise1.jpeg"),
          title: "Advanced 2D/3D Game Design",
          list: [
            "Stunning visual design with high-quality character modeling and immersive environments.",
            "Optimized graphics and animation systems for smooth performance across all devices.",
          ],
        },
        {
          img: require("../assets/images/services/game-dev/expertise2.jpeg"),
          title: "Unity Engine Development",
          list: [
            "Cross-platform game development using Unity's powerful and flexible engine.",
            "Advanced features including real-time rendering, physics simulation, and AI integration.",
          ],
        },
        {
          img: require("../assets/images/services/game-dev/expertise3.jpeg"),
          title: "Unreal Engine Excellence",
          list: [
            "High-performance games with photorealistic graphics and advanced physics simulation.",
            "Perfect for AAA titles, simulation games, and immersive VR experiences.",
          ],
        },
        {
          img: require("../assets/images/services/game-dev/expertise4.jpeg"),
          title: "Augmented Reality Gaming",
          list: [
            "Innovative AR experiences that blend digital content with the real world.",
            "Interactive storytelling and engaging gameplay that leverages mobile device capabilities.",
          ],
        },
        {
          img: require("../assets/images/services/game-dev/expertise5.jpeg"),
          title: "Virtual Reality Immersion",
          list: [
            "Immersive VR games designed for Oculus, HTC Vive, and PlayStation VR platforms.",
            "Realistic physics, spatial audio, and intuitive controls for truly immersive experiences.",
          ],
        },
        {
          img: require("../assets/images/services/game-dev/expertise6.jpeg"),
          title: "Multiplayer & Social Gaming",
          list: [
            "Real-time multiplayer functionality with advanced networking and synchronization.",
            "Social features including leaderboards, achievements, and community engagement tools.",
          ],
        },
        {
          img: require("../assets/images/services/game-dev/expertise7.jpeg"),
          title: "Educational & Training Games",
          list: [
            "Serious games for education, corporate training, and skill development.",
            "Gamified learning experiences that improve retention and engagement.",
          ],
        },
        {
          img: require("../assets/images/services/game-dev/expertise8.jpeg"),
          title: "Creative Storytelling & Design",
          list: [
            "Compelling narratives and character development that create emotional connections.",
            "Immersive world-building and environmental storytelling for memorable gaming experiences.",
          ],
        },
        {
          img: require("../assets/images/services/game-dev/expertise9.jpeg"),
          title: "Quality Assurance & Testing",
          list: [
            "Comprehensive testing protocols ensuring bug-free, optimized gameplay experiences.",
            "Performance optimization and compatibility testing across all target platforms.",
          ],
        },
        {
          img: require("../assets/images/services/game-dev/expertise10.jpeg"),
          title: "Monetization Strategy & Analytics",
          list: [
            "Intelligent monetization systems including ads, in-app purchases, and premium content.",
            "Analytics and player behavior tracking for continuous improvement and optimization.",
          ],
        },
      ],
      developmentProcess: [
        {
          img: require("../assets/images/services/game-dev/process1.jpeg"),
          title: "Game Concept & Strategic Planning",
          list: [
            "Comprehensive game design document creation with detailed mechanics and storylines.",
            "Market research and competitive analysis to ensure commercial viability and success.",
          ],
        },
        {
          img: require("../assets/images/services/game-dev/process2.jpeg"),
          title: "Creative Design & Prototyping",
          list: [
            "Character design, environment creation, and interactive prototype development.",
            "User experience testing and iterative design refinement based on player feedback.",
          ],
        },
        {
          img: require("../assets/images/services/game-dev/process3.jpeg"),
          title: "Advanced Development & Optimization",
          list: [
            "Full game development with advanced features, multiplayer functionality, and AI systems.",
            "Performance optimization and cross-platform compatibility testing for seamless deployment.",
          ],
        },
      ],
    },
  },
  {
    id: 7,
    title: "UI/UX Design",
    subHeading: "Crafting User Experiences That Drive Engagement and Conversion",
    image: require("../assets/images/services/uiux1.jpeg"),
    desc: "AIBSH TECHNOLOGIES PVT LTD creates exceptional user experiences that go beyond aesthetics to deliver meaningful interactions and measurable business results. We design intuitive, accessible, and engaging interfaces that connect with your users and drive your business objectives.",
    serviceDetails: {
      banner: require("../assets/images/services/uiux/banner.jpeg"),
      img1: require("../assets/images/services/uiux/1.jpeg"),
      img2: require("../assets/images/services/uiux/2.jpeg"),
      whyChooseContent: {
        heading: "Why AIBSH TECHNOLOGIES PVT LTD Excels in UI/UX Design Excellence",
        list: [
          {
            title: "User-Centric Design Philosophy",
            desc: "We put your users at the center of every design decision, creating intuitive experiences that anticipate needs and deliver seamless interactions that keep users engaged and satisfied.",
          },
          {
            title: "Strategic Design Thinking",
            desc: "Our design process goes beyond aesthetics to solve real business problems, creating user experiences that drive conversion, engagement, and measurable business outcomes.",
          },
          {
            title: "Cross-Platform Design Excellence",
            desc: "We create responsive, adaptive designs that work flawlessly across desktop, mobile, and tablet devices, ensuring consistent user experiences regardless of platform or screen size.",
          },
          {
            title: "Scalable Design Systems",
            desc: "We build comprehensive design systems that grow with your business, ensuring consistency, efficiency, and maintainability across all your digital products and platforms.",
          },
          {
            title: "Brand-Aligned Creative Excellence",
            desc: "We seamlessly integrate your brand identity into every design element, creating memorable experiences that strengthen brand recognition and build lasting user relationships.",
          },
        ],
      },
      ourExpertiseContent: [
        {
          img: require("../assets/images/services/uiux/expertise1.jpeg"),
          title: "Comprehensive User Research",
          list: [
            "In-depth user behavior analysis and needs assessment for informed design decisions.",
            "Market research and competitive analysis to identify opportunities and best practices.",
          ],
        },
        {
          img: require("../assets/images/services/uiux/expertise2.jpeg"),
          title: "Strategic Wireframing & Prototyping",
          list: [
            "Interactive wireframes and high-fidelity prototypes that bring concepts to life.",
            "User flow optimization and information architecture design for intuitive navigation.",
          ],
        },
        {
          img: require("../assets/images/services/uiux/expertise3.jpeg"),
          title: "Interactive Interface Design",
          list: [
            "Engaging and intuitive user interfaces that enhance user engagement and satisfaction.",
            "Micro-interactions and animations that create delightful user experiences.",
          ],
        },
        {
          img: require("../assets/images/services/uiux/expertise4.jpeg"),
          title: "Responsive & Adaptive Design",
          list: [
            "Mobile-first responsive design that adapts seamlessly across all devices and screen sizes.",
            "Progressive enhancement strategies for optimal performance on all platforms.",
          ],
        },
        {
          img: require("../assets/images/services/uiux/expertise5.jpeg"),
          title: "Strategic Brand Integration",
          list: [
            "Seamless integration of brand identity into every design element and interaction.",
            "Consistent visual language that reinforces brand recognition and builds trust.",
          ],
        },
        {
          img: require("../assets/images/services/uiux/expertise6.jpeg"),
          title: "Comprehensive Usability Testing",
          list: [
            "Real-user testing and feedback analysis to optimize user experience and functionality.",
            "Iterative design refinement based on user behavior and performance metrics.",
          ],
        },
        {
          img: require("../assets/images/services/uiux/expertise7.png"),
          title: "Accessibility & Inclusive Design",
          list: [
            "WCAG-compliant designs that ensure accessibility for users with disabilities.",
            "Inclusive design principles that create experiences for diverse user needs and abilities.",
          ],
        },
        {
          img: require("../assets/images/services/uiux/expertise8.jpeg"),
          title: "Visual Design Excellence",
          list: [
            "Stunning visual designs that capture attention and reinforce brand identity.",
            "Immersive and appealing user experiences that create emotional connections.",
          ],
        },
        {
          img: require("../assets/images/services/uiux/expertise9.jpeg"),
          title: "Comprehensive Design Systems",
          list: [
            "Scalable design systems with consistent UI components and design guidelines.",
            "Design tokens and component libraries for efficient development and maintenance.",
          ],
        },
      ],
      developmentProcess: [
        {
          img: require("../assets/images/services/uiux/process1.jpeg"),
          title: "Strategic Discovery & Research",
          list: [
            "Comprehensive analysis of business objectives, user needs, and technical requirements.",
            "Market research and competitive analysis to inform design strategy and opportunities.",
          ],
        },
        {
          img: require("../assets/images/services/uiux/process2.jpeg"),
          title: "User-Centered Design & Prototyping",
          list: [
            "Interactive wireframes and high-fidelity prototypes with user testing and iteration.",
            "Accessibility-focused design that ensures inclusive user experiences for all users.",
          ],
        },
        {
          img: require("../assets/images/services/uiux/process3.jpeg"),
          title: "Implementation & Quality Assurance",
          list: [
            "Design system implementation with comprehensive documentation and guidelines.",
            "Quality assurance and performance optimization for seamless user experiences.",
          ],
        },
      ],
    },
  },
];
